import { render, staticRenderFns } from "./OutDormitory.vue?vue&type=template&id=2d64f992&scoped=true"
import script from "./OutDormitory.vue?vue&type=script&lang=js"
export * from "./OutDormitory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d64f992",
  null
  
)

export default component.exports